import React from "react";
import { useNavigate } from "react-router-dom";
import "./backArrow.css";

const BackArrow = () => {
  const navigate = useNavigate();

  return (
    <div className="back-arrow" onClick={() => navigate(-1)}>
      ←
    </div>
  );
};

export default BackArrow;
